import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'react-toastify/dist/ReactToastify.css';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const win = window;
const Stimulsoft = win.Stimulsoft;

Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHnm4PeXL/fYEIRs8tb03jY5uQ6uegy3didg3xBnd4BzcYluwK" +
    "6HdjAXANB2V1IftftuvC8a5bvpYiiU/v9efaZjMukvILSbcdUzGj0qOG2Dn5MgaLoq/+jN+g0zejK2/qE8+MzxLaBl" +
    "vuk8fOiLazS0tTS0gfP3uPzYAZm8oXLxbPUEiL8wh9S7qroPscXFZS6J/rjPR9DcN9ynznwFMjHzRCtqy9pBmmFfFd" +
    "mSqj149QgJcEcJ0eLqDeiFkI2+GGFhucyLurYl1jH/PnzidAhSGnlcGIqJCfSGV63Podrnw8PJefzZ0K3s1ruqBReo" +
    "Ufy0C/+34FdLXFLuzRcjnoHNfoWB5syT+5hRc4oRrD1vmP2svoijfHYNONqZi3Y8gn69kmo9uqT8K5VbICl1v2/xfN" +
    "Tr3xpXD6NG7ib06HFm44jzYHT7pOCEK6tQiQaPhW014NqztjftMMqrQBTZE4suFHet2Q0HlOpW6tAp+3iQQHin8KUP" +
    "U6x9NknFzYiU2Y3zeQBNquE1L9lzFfyvRKRA";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <App />
    </BrowserRouter>,
    rootElement);

registerServiceWorker();

